export { MedicalConsultationHistory } from './MedicalConsultationHistory';
